import { AutogenModelCarrierCallinHistory, AutogenRowCarrierCallinHistory } from "./autogen/AutogenModelCarrierCallinHistory";

export class ModelCarrierCallinHistory extends AutogenModelCarrierCallinHistory<RowCarrierCallinHistory> {
	constructor() {
		super(RowCarrierCallinHistory);
	}
}

export class RowCarrierCallinHistory extends AutogenRowCarrierCallinHistory {
}